import { handleAction } from 'redux-actions';
import actions from '../actions';

const { toggle } = actions.orderDetail;

const orderDetail = handleAction(
  toggle,
  state => ({ ...state, active: !state.active }),
  {
    active: false,
  }
);

export default orderDetail;



// WEBPACK FOOTER //
// ./src/reducers/orderDetail.js